/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LoaTrustCertificateIssuerDN,
    LoaTrustCertificateIssuerDNFromJSON,
    LoaTrustCertificateIssuerDNFromJSONTyped,
    LoaTrustCertificateIssuerDNToJSON,
} from './LoaTrustCertificateIssuerDN';
import {
    LoaTrustCertificatePublicKey,
    LoaTrustCertificatePublicKeyFromJSON,
    LoaTrustCertificatePublicKeyFromJSONTyped,
    LoaTrustCertificatePublicKeyToJSON,
} from './LoaTrustCertificatePublicKey';
import {
    LoaTrustCertificateSubjectX500Principal,
    LoaTrustCertificateSubjectX500PrincipalFromJSON,
    LoaTrustCertificateSubjectX500PrincipalFromJSONTyped,
    LoaTrustCertificateSubjectX500PrincipalToJSON,
} from './LoaTrustCertificateSubjectX500Principal';

/**
 * 
 * @export
 * @interface LoaTrustCertificate
 */
export interface LoaTrustCertificate {
    /**
     * 
     * @type {string}
     * @memberof LoaTrustCertificate
     */
    type?: string;
    /**
     * 
     * @type {LoaTrustCertificateSubjectX500Principal}
     * @memberof LoaTrustCertificate
     */
    subjectX500Principal?: LoaTrustCertificateSubjectX500Principal;
    /**
     * 
     * @type {LoaTrustCertificateSubjectX500Principal}
     * @memberof LoaTrustCertificate
     */
    issuerX500Principal?: LoaTrustCertificateSubjectX500Principal;
    /**
     * 
     * @type {Blob}
     * @memberof LoaTrustCertificate
     */
    signature?: Blob;
    /**
     * 
     * @type {number}
     * @memberof LoaTrustCertificate
     */
    basicConstraints?: number;
    /**
     * 
     * @type {number}
     * @memberof LoaTrustCertificate
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof LoaTrustCertificate
     */
    serialNumber?: number;
    /**
     * 
     * @type {LoaTrustCertificateIssuerDN}
     * @memberof LoaTrustCertificate
     */
    issuerDN?: LoaTrustCertificateIssuerDN;
    /**
     * 
     * @type {LoaTrustCertificateIssuerDN}
     * @memberof LoaTrustCertificate
     */
    subjectDN?: LoaTrustCertificateIssuerDN;
    /**
     * 
     * @type {Date}
     * @memberof LoaTrustCertificate
     */
    notBefore?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LoaTrustCertificate
     */
    notAfter?: Date;
    /**
     * 
     * @type {Blob}
     * @memberof LoaTrustCertificate
     */
    tbscertificate?: Blob;
    /**
     * 
     * @type {string}
     * @memberof LoaTrustCertificate
     */
    sigAlgName?: string;
    /**
     * 
     * @type {string}
     * @memberof LoaTrustCertificate
     */
    sigAlgOID?: string;
    /**
     * 
     * @type {Blob}
     * @memberof LoaTrustCertificate
     */
    sigAlgParams?: Blob;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof LoaTrustCertificate
     */
    issuerUniqueID?: Array<boolean>;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof LoaTrustCertificate
     */
    subjectUniqueID?: Array<boolean>;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof LoaTrustCertificate
     */
    keyUsage?: Array<boolean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoaTrustCertificate
     */
    extendedKeyUsage?: Array<string>;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof LoaTrustCertificate
     */
    subjectAlternativeNames?: Array<Array<object>>;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof LoaTrustCertificate
     */
    issuerAlternativeNames?: Array<Array<object>>;
    /**
     * 
     * @type {Set<string>}
     * @memberof LoaTrustCertificate
     */
    criticalExtensionOIDs?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof LoaTrustCertificate
     */
    nonCriticalExtensionOIDs?: Set<string>;
    /**
     * 
     * @type {Blob}
     * @memberof LoaTrustCertificate
     */
    encoded?: Blob;
    /**
     * 
     * @type {LoaTrustCertificatePublicKey}
     * @memberof LoaTrustCertificate
     */
    publicKey?: LoaTrustCertificatePublicKey;
}

export function LoaTrustCertificateFromJSON(json: any): LoaTrustCertificate {
    return LoaTrustCertificateFromJSONTyped(json, false);
}

export function LoaTrustCertificateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoaTrustCertificate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'subjectX500Principal': !exists(json, 'subjectX500Principal') ? undefined : LoaTrustCertificateSubjectX500PrincipalFromJSON(json['subjectX500Principal']),
        'issuerX500Principal': !exists(json, 'issuerX500Principal') ? undefined : LoaTrustCertificateSubjectX500PrincipalFromJSON(json['issuerX500Principal']),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'basicConstraints': !exists(json, 'basicConstraints') ? undefined : json['basicConstraints'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'issuerDN': !exists(json, 'issuerDN') ? undefined : LoaTrustCertificateIssuerDNFromJSON(json['issuerDN']),
        'subjectDN': !exists(json, 'subjectDN') ? undefined : LoaTrustCertificateIssuerDNFromJSON(json['subjectDN']),
        'notBefore': !exists(json, 'notBefore') ? undefined : (new Date(json['notBefore'])),
        'notAfter': !exists(json, 'notAfter') ? undefined : (new Date(json['notAfter'])),
        'tbscertificate': !exists(json, 'tbscertificate') ? undefined : json['tbscertificate'],
        'sigAlgName': !exists(json, 'sigAlgName') ? undefined : json['sigAlgName'],
        'sigAlgOID': !exists(json, 'sigAlgOID') ? undefined : json['sigAlgOID'],
        'sigAlgParams': !exists(json, 'sigAlgParams') ? undefined : json['sigAlgParams'],
        'issuerUniqueID': !exists(json, 'issuerUniqueID') ? undefined : json['issuerUniqueID'],
        'subjectUniqueID': !exists(json, 'subjectUniqueID') ? undefined : json['subjectUniqueID'],
        'keyUsage': !exists(json, 'keyUsage') ? undefined : json['keyUsage'],
        'extendedKeyUsage': !exists(json, 'extendedKeyUsage') ? undefined : json['extendedKeyUsage'],
        'subjectAlternativeNames': !exists(json, 'subjectAlternativeNames') ? undefined : json['subjectAlternativeNames'],
        'issuerAlternativeNames': !exists(json, 'issuerAlternativeNames') ? undefined : json['issuerAlternativeNames'],
        'criticalExtensionOIDs': !exists(json, 'criticalExtensionOIDs') ? undefined : json['criticalExtensionOIDs'],
        'nonCriticalExtensionOIDs': !exists(json, 'nonCriticalExtensionOIDs') ? undefined : json['nonCriticalExtensionOIDs'],
        'encoded': !exists(json, 'encoded') ? undefined : json['encoded'],
        'publicKey': !exists(json, 'publicKey') ? undefined : LoaTrustCertificatePublicKeyFromJSON(json['publicKey']),
    };
}

export function LoaTrustCertificateToJSON(value?: LoaTrustCertificate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'subjectX500Principal': LoaTrustCertificateSubjectX500PrincipalToJSON(value.subjectX500Principal),
        'issuerX500Principal': LoaTrustCertificateSubjectX500PrincipalToJSON(value.issuerX500Principal),
        'signature': value.signature,
        'basicConstraints': value.basicConstraints,
        'version': value.version,
        'serialNumber': value.serialNumber,
        'issuerDN': LoaTrustCertificateIssuerDNToJSON(value.issuerDN),
        'subjectDN': LoaTrustCertificateIssuerDNToJSON(value.subjectDN),
        'notBefore': value.notBefore === undefined ? undefined : (value.notBefore.toISOString()),
        'notAfter': value.notAfter === undefined ? undefined : (value.notAfter.toISOString()),
        'tbscertificate': value.tbscertificate,
        'sigAlgName': value.sigAlgName,
        'sigAlgOID': value.sigAlgOID,
        'sigAlgParams': value.sigAlgParams,
        'issuerUniqueID': value.issuerUniqueID,
        'subjectUniqueID': value.subjectUniqueID,
        'keyUsage': value.keyUsage,
        'extendedKeyUsage': value.extendedKeyUsage,
        'subjectAlternativeNames': value.subjectAlternativeNames,
        'issuerAlternativeNames': value.issuerAlternativeNames,
        'criticalExtensionOIDs': value.criticalExtensionOIDs,
        'nonCriticalExtensionOIDs': value.nonCriticalExtensionOIDs,
        'encoded': value.encoded,
        'publicKey': LoaTrustCertificatePublicKeyToJSON(value.publicKey),
    };
}

